import React, { MouseEvent } from 'react';
import { Form, FormControlProps } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

type DateInputProps = FormControlProps & {
  label?: string;
  error?: string;
  min?: string;
  max?: string;
};

export const DateInput = React.forwardRef<FormControlProps, DateInputProps>(
  ({ label, error, min, max, ...props }: DateInputProps, ref) => (
    <Form.Group>
      {label && <Form.Label className="text-16px">{label}</Form.Label>}

      <FormControl
        ref={ref}
        type="date"
        min={min}
        max={max}
        onClick={(e: MouseEvent<HTMLInputElement>) => e.currentTarget.showPicker()}
        {...props}
      />

      {error && (
        <Form.Text className="text-danger">
          <Trans>{error}</Trans>
        </Form.Text>
      )}
    </Form.Group>
  ),
);

DateInput.displayName = `DateInput`;

const FormControl = styled(Form.Control)`
  padding: 0.75rem;
  height: 48px;
  background-color: ${(props) => (props.disabled ? `#F2F2F2` : `white`)} !important;
`;